<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/tXEUDi/tc-custom/9780226305196.jpg?1732136987063" alt="This image is the cover for the book Cicero on the Emotions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cicero on the Emotions
      </h1>
      <p class="bookDescription body article font2">
        <p>The third and fourth books of Cicero's <i>Tusculan Disputations</i> deal with the nature and management of human emotion: first grief, then the emotions in general. In lively and accessible style, Cicero presents the insights of Greek philosophers on the subject, reporting the views of Epicureans and Peripatetics and giving a detailed account of the Stoic position, which he himself favors for its close reasoning and moral earnestness. Both the specialist and the general reader will be fascinated by the Stoics' analysis of the causes of grief, their classification of emotions by genus and species, their lists of oddly named character flaws, and by the philosophical debate that develops over the utility of anger in politics and war.<br/><br/> Margaret Graver's elegant and idiomatic translation makes Cicero's work accessible not just to classicists but to anyone interested in ancient philosophy and psychotherapy or in the philosophy of emotion. The accompanying commentary explains the philosophical concepts discussed in the text and supplies many helpful parallels from Greek sources.<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcus Tullius, Margaret Graver
      </h2>
      
      <p class="authorDescription body article"><B>Margaret Graver</B> is an assistant professor of classics at Dartmouth College.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3627893f